/* eslint-disable import/no-unresolved */
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import RichText, { fragment } from '../../../Core/RichText';
import IndividualBlade from '../../IndividualBlades';
import { ResponsiveContext } from '../../../Providers/Responsive';
import Carousel from '../../../Core/Carousel';

import {
  StyledContainer,
  Heading,
  Footer,
  Btn,
  StyledPhone,
  StepContainers,
  StepNumber,
} from './styles';

// * heading {Obj/Richtext} - Richtext node for the card headline
// * blocks {array} - array of data objs for each card / block

const breakpoints = {
  320: {
    slidesPerView: '1',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: '3',
    spaceBetween: 24,
  },
};

const MobileCarouselBanner = ({ data, showScreenNumber = true }) => {
  if (!data) return null;
  const {
    component,
    cards,
    ctas,
    CtaMessage,
    elements,
    sectionContainerHeading,
    backgroundColor,
    contentAlignment,
  } = data;

  const carouselItems = cards || elements;

  const handleSlideChange = s => {
    if (s) {
      const stepContainer = document.querySelector('.step-container');
      if (stepContainer) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < stepContainer.children.length; i++) {
          stepContainer.children[i].classList.remove('active');
        }
        stepContainer.children[s.activeIndex].classList.add('active');
      }
    }
  };

  const { mobile } = useContext(ResponsiveContext);

  return (
    <StyledContainer
      className={`columns-${carouselItems.length} ${component} auto-margin`}
      backgroundColor={carouselItems.length === 4 ? 'white' : 'transparent'}
    >
      {sectionContainerHeading && (
        <Heading
          className={`${contentAlignment} columns-${carouselItems.length}`}
        >
          <RichText document={sectionContainerHeading} />
        </Heading>
      )}
      {mobile && showScreenNumber && (
        <StepContainers className={`${backgroundColor} step-container`}>
          {carouselItems.map((item, idx) => {
            return (
              <StepNumber key={`step-${item.id}`}>
                <p>{idx + 1}</p>
              </StepNumber>
            );
          })}
        </StepContainers>
      )}
      <Carousel
        breakpoints={breakpoints}
        onSlideChange={handleSlideChange}
        onInit={handleSlideChange}
        modules={[Pagination]}
        pagination={{ clickable: true }}
      >
        {carouselItems.map((product, indx) => {
          return (
            <SwiperSlide>
              <StyledPhone
                key={product.id}
                data={product}
                index={indx + 1}
                component={component}
                backgroundColor={backgroundColor}
              />
            </SwiperSlide>
          );
        })}
      </Carousel>
      {(CtaMessage || ctas) && (
        <Footer>
          {CtaMessage && <h3>{CtaMessage}</h3>}
          {ctas &&
            ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return cta.internal.type === 'ContentfulBlade' ? (
                <IndividualBlade key={cta.id} data={cta} />
              ) : (
                <Btn key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Btn>
              );
            })}
        </Footer>
      )}
    </StyledContainer>
  );
};

MobileCarouselBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  showScreenNumber: PropTypes.bool,
};

export default MobileCarouselBanner;
